import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { useState } from "react";
import ExpertDataService from "../../services/Expert";
export const AddLeaveModal = ({ isOpen, onClose, func ,id}: any) => {
    const [date, setDate] = useState<any>("");
    const [startTime, setStartTime] = useState<any>("");
    const [endTime, setEndTime] = useState<any>("");
    const [timings,setTimings]= useState<any>([]);
    function formatDate(inputDate:any) {
        const parts = inputDate.split('-');
        const year = parts[0];
        const month = parts[1];
        const day = parts[2];
        const formattedDate = `${day}/${month}/${year}`;
        return formattedDate
      }
      const handleRemove = (el: any) => {
        const filteredArray = timings.filter((data: any) => data !== el);
        setTimings(filteredArray);
      };
      const addMoreTimingSlot = () =>{
        setTimings([...timings,{start:startTime,end:endTime}])
        setStartTime("");
        setEndTime("");
      }
      const handleClick = async () =>{
          const formattedDate = formatDate(date);
          let time =  []
          if(date&&startTime&&endTime){
               time = [...timings,{start:startTime,end:endTime}]
          }
          else{
            time = [...timings]
          }
        ExpertDataService.postCalenderLeaveInfo(id, {date:formattedDate,timings:time})
      .then((res: any) => {
          func();
      })
      .catch((error: any) => {
        console.log(error);
      });
      setStartTime("");
        setEndTime("");
        setDate("");
        setTimings([]);
    onClose();
      }
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
          setDate("");
          setStartTime("");
          setEndTime("");
        onClose();
        setTimings([]);
      }}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add Leave</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <FormControl>
            <FormLabel>Date</FormLabel>
            <Input
              value={date}
              onChange={((e) => setDate(e.target.value))}
              type="date"
              placeholder="Last name"
            />
          </FormControl>
          <Flex>
            <FormControl mt={4}>
              <FormLabel>Start Time </FormLabel>
              <Input
                value={startTime}
                onChange={(e) => setStartTime(e.target.value)}
                type="time"
                placeholder="Last name"
              />
            </FormControl>
            <FormControl mt={4}>
              <FormLabel>End Time</FormLabel>
              <Input
                value={endTime}
                onChange={(e) => setEndTime(e.target.value)}
                type="time"
                placeholder="Last name"
              />
            </FormControl>
          </Flex>
          {timings.length > 0
            ? timings.map((el: any, index: number) => {
                return (
                  <div key={index}>
                    <Flex
                      className="expert_time"
                      justifyContent={"space-evenly"}
                    >
                      <div>Start : {el.start}</div>
                      <div>End : {el.end}</div>
                      <div className="pointer" onClick={() => handleRemove(el)}>
                        Remove
                      </div>
                    </Flex>
                  </div>
                );
              })
            : null}
        </ModalBody>

        <ModalFooter>
        <Button
            colorScheme="blue"
            mr={3}

              onClick={addMoreTimingSlot}
          >
            Add More
          </Button>
          <Button
            colorScheme="blue"
            mr={3}
              onClick={handleClick}
          >
            Save
          </Button>
          <Button
            onClick={() => {
              onClose();
              setDate("")
              setStartTime("");
              setEndTime("");
              setTimings([]);
            }}
          >
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
